import React, { Component } from 'react'

import styled, { css } from 'styled-components'
import { v4 as uuid } from 'uuid'

import mediaQueries from 'components/media-queries'

const Container = styled.label`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  cursor: pointer;

  ${props =>
    !props.notCenter &&
    css`
      ${mediaQueries.tablet`
      justify-content: center;
    `};
    `};
`

const Text = styled.label`
  height: 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.19;
  letter-spacing: 0.3px;
  text-align: center;
  color: ${({ theme }) => theme.colors.blue};
  margin-left: 10px;
  font-family: ${({ theme }) => theme.fonts.semiBold};

  ${mediaQueries.tablet`
    font-size: 16px;
  `};
`

const CheckboxInput = styled.input.attrs(props => ({
  type: 'checkbox',
  className: `switch-${props.name}`,
  checked: props.$checked ? true : undefined
}))`
  //Invisible but available to accessible tech
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 0;
  //

  & + div {
    flex-basis: 45px;
    height: 20px;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.gray55};
  }

  &:checked + div {
    background-color: ${({ theme }) => theme.colors.blue};

    ${props =>
      props.disabled &&
      css`
        background-color: ${({ theme }) => theme.colors.grayLight};
        border-color: ${({ theme }) => theme.colors.grayLight};
      `};
  }

  &:focus + div {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }

  & + div span {
    display: flex;
    width: 18px;
    height: 18px;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
    margin-left: 1px;
    margin-top: 1px;
    transition: 250ms;

    ${props =>
      props.disabled &&
      css`
        background-color: ${({ theme }) => theme.colors.grayLighter};
      `};
  }

  &:checked + div span {
    margin-left: 26px;
  }
`

class Switcher extends Component {
  handleChange = () => {
    if (!this.props.disabled) {
      this.props.onChange({ checked: !this.props.checked })
    }
  }

  static defaultProps = {
    onChange: () => {}
  }

  componentDidMount() {
    this.checkboxId = uuid()
  }

  render() {
    const checked = this.props.checked || false
    return (
      <Container notCenter={this.props.notCenter}>
        <CheckboxInput
          id={this.checkboxId}
          value={checked}
          $checked={checked}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          name={this.props.name || ''}
        />
        <div className={this.props.e2eClass} aria-hidden>
          <span />
        </div>
        <Text htmlFor={this.checkboxId}>{this.props.textRight}</Text>
      </Container>
    )
  }
}

export default Switcher
